module.exports = __webpack_public_path__ + "img/barcode_icon.0ad825fc.svg";